{
  "metadata": {
    "id": "ayu-dark",
    "name": "Ayu",
    "description": "Портировано из темы «Ayu» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "ayu.json",
      "project": "ayu-theme",
      "url": "https://github.com/ayu-theme/ayu-vim",
      "upstreamFile": "packages/ui/src/theme/themes/ayu.json",
      "license": "Apache-2.0",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.7,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.453,
      "paletteMaxS": 0.533,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 19.5,
      "syntaxVsTextMinDeltaE": 27.2,
      "chartsMinDeltaE": 32.1,
      "textSeparationDeltaE": 23.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "type",
          "deltaE": 11.6
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#3fb7e3",
      "hover": "#56c0e6",
      "active": "#65c5e9",
      "foreground": "#000000",
      "muted": "#3fb7e380",
      "emphasis": "#3fb7e3"
    },
    "surface": {
      "background": "#0f1419",
      "foreground": "#d6dae0",
      "muted": "#23292e",
      "mutedForeground": "#94999e",
      "elevated": "#2c3237",
      "elevatedForeground": "#d6dae0",
      "raised": "#464b50",
      "raisedForeground": "#d6dae0",
      "overlay": "#0f1419cc",
      "subtle": "#1a2025"
    },
    "interactive": {
      "border": "#484d53",
      "borderHover": "#474b51",
      "borderFocus": "#3fb7e3",
      "selection": "#d6dae029",
      "selectionForeground": "#d6dae0",
      "focus": "#3fb7e359",
      "focusRing": "#3fb7e361",
      "cursor": "#d6dae0",
      "hover": "#d6dae01c",
      "active": "#d6dae029"
    },
    "status": {
      "error": "#f58572",
      "errorForeground": "#000000",
      "errorBackground": "#f5857224",
      "errorBorder": "#f5857273",
      "warning": "#e4a75c",
      "warningForeground": "#000000",
      "warningBackground": "#e4a75c24",
      "warningBorder": "#e4a75c73",
      "success": "#78d05c",
      "successForeground": "#000000",
      "successBackground": "#78d05c24",
      "successBorder": "#78d05c73",
      "info": "#66c6f1",
      "infoForeground": "#000000",
      "infoBackground": "#66c6f124",
      "infoBorder": "#66c6f173"
    },
    "pr": {
      "open": "#78d05c",
      "draft": "#9b9fa4",
      "blocked": "#e4a75c",
      "merged": "#f2856f",
      "closed": "#f58572"
    },
    "syntax": {
      "base": {
        "background": "#32373c",
        "foreground": "#d6dae0",
        "comment": "#8fa5bc",
        "keyword": "#ff8f40",
        "string": "#aad94c",
        "number": "#d2a6ff",
        "function": "#39bae6",
        "variable": "#d6dae0",
        "type": "#59c2ff",
        "operator": "#b6c0b6"
      },
      "tokens": {
        "commentDoc": "#8fa5bc",
        "stringEscape": "#b6c0b6",
        "keywordImport": "#ff8f40",
        "storageModifier": "#ff8f40",
        "functionCall": "#39bae6",
        "method": "#39bae6",
        "variableProperty": "#39bae6",
        "variableOther": "#d6dae0",
        "variableGlobal": "#d2a6ff",
        "variableLocal": "#b6c0b6",
        "parameter": "#d6dae0",
        "constant": "#d2a6ff",
        "class": "#59c2ff",
        "className": "#59c2ff",
        "interface": "#59c2ff",
        "struct": "#59c2ff",
        "enum": "#59c2ff",
        "typeParameter": "#59c2ff",
        "namespace": "#59c2ff",
        "module": "#ff8f40",
        "tag": "#ff8f40",
        "jsxTag": "#ff8f40",
        "tagAttribute": "#39bae6",
        "tagAttributeValue": "#aad94c",
        "boolean": "#d2a6ff",
        "decorator": "#ff8f40",
        "label": "#39bae6",
        "regexp": "#aad94c"
      }
    },
    "charts": {
      "series": [
        "#3fb7e3",
        "#6698f1",
        "#78d05c",
        "#e4a75c",
        "#f58572"
      ]
    },
    "chat": {
      "background": "#0f1419",
      "userMessage": "#d6dae0",
      "userMessageBackground": "#2c3237",
      "assistantMessage": "#d6dae0",
      "assistantMessageBackground": "#23292e",
      "timestamp": "#9b9fa4",
      "divider": "#484d53",
      "typing": "#9b9fa4"
    },
    "loading": {
      "spinner": "#3fb7e3",
      "spinnerTrack": "#23292e",
      "skeleton": "#23292e",
      "shimmer": "#3c4146"
    },
    "tools": {
      "background": "#23292e",
      "border": "#484d53",
      "headerHover": "#3a3f44",
      "icon": "#3fb7e3",
      "title": "#d6dae0",
      "description": "#9b9fa4",
      "edit": {
        "added": "#78d05c",
        "addedBackground": "#78d05c24",
        "removed": "#f58572",
        "removedBackground": "#f5857224",
        "modified": "#66c6f1",
        "modifiedBackground": "#66c6f124",
        "lineNumber": "#9b9fa4"
      }
    },
    "markdown": {
      "heading1": "#d6dae0",
      "heading2": "#d6dae0",
      "heading3": "#d6dae0",
      "heading4": "#d6dae0",
      "link": "#3fb7e3",
      "linkHover": "#56c0e6",
      "inlineCode": "#aad94c",
      "inlineCodeBackground": "#23292e",
      "blockquote": "#9b9fa4",
      "blockquoteBorder": "#484d53",
      "listMarker": "#3fb7e3bf",
      "bold": "#d6dae0",
      "italic": "#d6dae0e6",
      "strikethrough": "#9b9fa4",
      "hr": "#484d53"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#be454c",
        "foreground": "#ffffff",
        "contrast": 5.07
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#c07246",
        "foreground": "#000000",
        "contrast": 5.74
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d9bfa1",
        "foreground": "#000000",
        "contrast": 11.92
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bcbb5a",
        "foreground": "#000000",
        "contrast": 10.39
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#8ac652",
        "foreground": "#000000",
        "contrast": 10.28
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#b0dba3",
        "foreground": "#000000",
        "contrast": 13.51
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#54c57b",
        "foreground": "#000000",
        "contrast": 9.65
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#59bb9e",
        "foreground": "#000000",
        "contrast": 9.03
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#a4dadb",
        "foreground": "#000000",
        "contrast": 13.63
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#529ab7",
        "foreground": "#000000",
        "contrast": 6.66
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4a73b3",
        "foreground": "#ffffff",
        "contrast": 4.78
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3841b8",
        "foreground": "#ffffff",
        "contrast": 8.03
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#ba9ed6",
        "foreground": "#000000",
        "contrast": 8.95
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b971cd",
        "foreground": "#000000",
        "contrast": 6.31
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf4792",
        "foreground": "#ffffff",
        "contrast": 4.63
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c77895",
        "foreground": "#000000",
        "contrast": 6.55
      }
    ]
  }
}
